import { Link } from "react-router-dom";

interface VideoCardProps {
  id: number;
  title: string;
  category: string;
  categoryName: string;
  thumbnail: string;
  duration: string;
  views: number;
  date: string;
  author?: string;
  size?: "normal" | "large";
}

export default function VideoCard({
  id,
  title,
  category,
  categoryName,
  thumbnail,
  duration,
  views,
  date,
  size = "normal",
}: VideoCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg mb-3 ${size === "large" ? "aspect-video" : "aspect-video"}`}>
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded-md whitespace-nowrap">
          {duration}
        </span>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <h3 className={`font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug ${size === "large" ? "text-lg" : "text-sm"}`}>
        {title}
      </h3>
      <div className="flex items-center gap-3 mt-2 flex-wrap">
        <span className="text-xs px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap">
          {categoryName}
        </span>
        <span className="text-xs text-foreground-500 whitespace-nowrap">
          <i className="ri-eye-line mr-1"></i>{formatViews(views)}
        </span>
        <span className="text-xs text-foreground-500 whitespace-nowrap">{date}</span>
      </div>
    </Link>
  );
}